module.exports = __webpack_public_path__ + "static/img/guoxiangwang.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stars/guoxiangwang.jpg
// module id = lKZF
// module chunks = 0